// import store from '@/store';
import { io } from "socket.io-client";

const WS_URL = process.env.WEBSOCKETS_URL;

const connect = () => {
  console.log('connecting');
  const socketConnection = io(WS_URL, {
    // query: `token=`,
    transports: ['websocket'],
  });

  socketConnection.on('disconnect', () => {
    console.log('disconnect')
  });

  const onevent = socketConnection.onevent;

  socketConnection.onevent = function (packet) {
    const args = packet.data || [];
    // if (args.length > 0) {
    //   try {
    //     // store.dispatch(`SOCKET_${args[0].toUpperCase()}`, args[1]);
    //   } catch (ex) {
    //     console.log(ex);
    //   }
    // }
    onevent.call(this, packet);

    packet.data = ['*'].concat(args);
    onevent.call(this, packet.data);
  };
  return socketConnection;
};
export default connect;
